import { useState } from "react";

interface IAIScribeContentStateReturn {
    isRecording: boolean;
    currentRecordingDuration: number;
    hasAIScribeContentChanged: () => boolean;
    startRecording: () => void;
    stopRecording: (duration: number) => void;
    setErrorReason: React.Dispatch<React.SetStateAction<string>>
    resetAIScribeContentState: () => void;
}

function useAIScribeContentState(): IAIScribeContentStateReturn {
    const [isRecording, setIsRecording] = useState(false);
    const [currentRecordingDuration, setCurrentRecordingDuration] = useState(0);
    const [errorReason, setErrorReason] = useState("");

    const resetAIScribeContentState = (): void => {
        setIsRecording(false);
        setCurrentRecordingDuration(0);
        setErrorReason("");
    };

    const startRecording = (): void => {
        setIsRecording(true);
    };

    const stopRecording = (duration: number): void => {
        setIsRecording(false);
        setCurrentRecordingDuration(duration);
    };

    const hasAIScribeContentChanged = (): boolean => !errorReason && (isRecording || currentRecordingDuration > 0);

    return {
        isRecording,
        currentRecordingDuration,
        hasAIScribeContentChanged,
        startRecording,
        stopRecording,
        setErrorReason,
        resetAIScribeContentState
    };
}

export default useAIScribeContentState;
